import Vue from 'vue';
import vuescroll from 'vuescroll';

import gravityGateway from '@/services/gravityGateway';
import filters from '@/filters';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
Vue.use(filters);
Vue.use(vuescroll, {
  ops: {
    bar: {
      onlyShowBarOnScroll: false,
      background: '#000',
      opacity: 0.5,
    },
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    const { settings } = store.state;

    if (settings.gateway) {
      gravityGateway.init().then((data) => {
        // NOTE: All settings are passed as url query params
        // This part can be refactored some time later
        store.dispatch('updateSettings', data);
      });
    }

    store.dispatch('getTranslations', settings.language);
  },
}).$mount('#app');
